import * as Sentry from "@sentry/browser"

// Only initialize Sentry if the hostname is NOT localhost
Sentry.init({
  dsn: process.env.SENTRY_DSN,
  enabled: process.env.SENTRY_ENABLED === "true",
  environment: process.env.SENTRY_ENVIRONMENT,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserSessionIntegration(),
  ],
  release: process.env.SENTRY_RELEASE,
  sampleRate: 0.7,
  tracesSampleRate: 0.2,
})
